"use client";
import { Input } from "@/components/Input";
import { FC, useContext } from "react";
import { IndexCardsContext } from "./IndexContextBlock";
import { getHrefFromCustomUrlPlugin } from "@/helpers";
import { BuilderBlockProps } from "@/types";

type FilterSearchBlockType = {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  placeholder: string;
  helperText: string;
  hideSuggestions?: boolean;
  maxSuggestions?: number;
  searchIconAriaLabel?: string;
  resetSearchIconAriaLabel?: string;
};

export const FilterSearchBlock: FC<
  FilterSearchBlockType & BuilderBlockProps
> = ({
  value,
  placeholder,
  helperText,
  onChange,
  onSearch,
  hideSuggestions = false,
  maxSuggestions,
  attributes,
  searchIconAriaLabel,
  resetSearchIconAriaLabel,
}) => {
  const { cards } = useContext(IndexCardsContext);
  const { ariaLabel, ...wrapperAttributes } = attributes;

  const filteredCards = hideSuggestions
    ? []
    : (cards
        ?.filter(({ data }) =>
          value
            ? data.title?.toLowerCase().includes(value.toLowerCase()) ||
              data.description?.toLowerCase().includes(value.toLowerCase()) ||
              (data.type === "CVE" &&
                (data.index?.toLowerCase().includes(value.toLowerCase()) ||
                  data.fixedVersion
                    ?.toLowerCase()
                    .includes(value.toLowerCase())))
            : true,
        )
        .map(({ data }) => ({
          type: "link" as const,
          title: data.title ?? data.link.title ?? "",
          href: getHrefFromCustomUrlPlugin(data.link.url ?? "/"),
          dld: data.link.dld ?? "",
          dlt: data.link.dlt ?? "",
        })) ?? []);

  return (
    <div {...wrapperAttributes}>
      <Input
        type="search"
        variant="rectangular"
        formControlContainerClassName="bg-background"
        value={value ?? ""}
        onChange={onChange}
        onSearch={onSearch}
        placeholder={placeholder}
        aria-label={ariaLabel}
        searchIconAriaLabel={searchIconAriaLabel}
        resetSearchIconAriaLabel={resetSearchIconAriaLabel}
        maxSuggestions={maxSuggestions}
        suggestions={
          hideSuggestions
            ? []
            : [
                ...(helperText && filteredCards.length > 0
                  ? [
                      {
                        type: "search" as const,
                        label: helperText,
                        value: "",
                        disabled: true,
                      },
                    ]
                  : []),
                ...filteredCards,
              ]
        }
      />
    </div>
  );
};
